import { render, staticRenderFns } from "./ParentRegisterStatusReport.vue?vue&type=template&id=a1e5eae4&scoped=true"
import script from "./ParentRegisterStatusReport.vue?vue&type=script&lang=js"
export * from "./ParentRegisterStatusReport.vue?vue&type=script&lang=js"
import style0 from "./ParentRegisterStatusReport.vue?vue&type=style&index=0&id=a1e5eae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e5eae4",
  null
  
)

export default component.exports